import type { ReactNode } from 'react';
import { BORDER_COLORS } from '@/common/presentation/constants/colors';

interface Props {
  pageNumber: number;
  children?: ReactNode;
}

const label = (pageNumber: number) => `— page ${pageNumber} —`;

export function PageBreakIndicator({ pageNumber }: Props) {
  return (
    <div
      aria-label="page-break-indicator"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        margin: '16px 0',
        color: 'var(--rdb-text-color)'
      }}
    >
      <div style={{ flex: 1, borderTop: `2px dashed ${BORDER_COLORS.DASHED}` }} />
      <div style={{ fontSize: 12, fontWeight: 700 }}>{label(pageNumber)}</div>
      <div style={{ flex: 1, borderTop: `2px dashed ${BORDER_COLORS.DASHED}` }} />
    </div>
  );
}
